export class RestorePasswordRequest {
  public token: string;
  public password: string;
}
